export default __webpack_public_path__ + "assets/star.1de4e5ed.svg";